import BaseModel from '@core/model';

import i18n from '@plugins/i18n';

import { PhoneNumber, Address } from '@/models';

export class PowerOfAttorney extends BaseModel {
    static entity = 'powerOfAttorney';

    static fields() {
        return {
            ...super.fields(),
            id: this.string(null).nullable(),
            title: this.string(null).nullable(),
            name: this.string(null).nullable(),
            firm_name: this.string(null).nullable(),
            email: this.string(null).nullable(),
            dob: this.string(null).nullable(),
            phone_number: this.model(PhoneNumber).nullable(),
            address: this.model(Address).nullable()
        };
    }

    get is_valid() {
        return [this.name, this.email, this.phone_number, this.address].every(v => v);
    }

    get computed_name() {
        if (this.is_valid) {
            return (this.title ? this.title + ' ' : '') + this.name;
        }
        return i18n.t('power_of_attorney');
    }
}

export default PowerOfAttorney;
